import { openTheModal } from "./functions";

document.addEventListener('click', e => {
    const target = e.target.closest('[data-hint]')

    if (!target) return

    openTheModal(`[data-target="${target.dataset.hint}"]`)
})
